import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { MailCheck } from "lucide-react";

const inputCls =
  "w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400";

export default function ClubeRecuperar() {
  const [email, setEmail] = useState("");
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || loading) return;
    setLoading(true);
    try {
      await api.post("/indicadores/esqueci-senha", { email: email.trim() });
    } catch {}
    setLoading(false);
    setEnviado(true);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6" data-testid="clube-recuperar">
      <div className="w-full max-w-sm">
        <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="h-16 w-auto object-contain rounded-xl bg-white p-1 mb-6 mx-auto border border-slate-100" />
        <h1 className="font-heading text-xl font-bold text-navy text-center">Recuperar senha</h1>
        {enviado ? (
          <div className="mt-6 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 text-center" data-testid="clube-recuperar-ok">
            <MailCheck className="w-8 h-8 text-[#F5B301] mx-auto mb-2" />
            <p className="text-sm text-slate-600">
              Se este e-mail estiver cadastrado, você receberá o link de redefinição. O link expira em 1 hora.
            </p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 bg-white rounded-2xl border border-slate-100 shadow-sm p-5 space-y-4">
            <p className="text-xs text-slate-500">Informe o e-mail cadastrado no Clube de Indicadores.</p>
            <div>
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">E-mail</label>
              <input
                type="email"
                data-testid="clube-recuperar-email"
                className={`${inputCls} mt-1`}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
              />
            </div>
            <button
              type="submit"
              data-testid="clube-recuperar-btn"
              disabled={loading}
              className="w-full py-3.5 rounded-xl bg-navy text-white font-extrabold text-sm active:scale-95 transition-transform disabled:opacity-50"
            >
              {loading ? "ENVIANDO..." : "ENVIAR LINK DE REDEFINIÇÃO"}
            </button>
          </form>
        )}
        <Link to="/clube/login" className="block text-center mt-4 text-xs text-navy font-semibold underline" data-testid="clube-recuperar-voltar">
          Voltar para o login
        </Link>
      </div>
    </div>
  );
}
